module.exports = __webpack_public_path__ + "static/media/Øving-1.8a6f49b0.mp3";